import apiSlice from "./ApiSlice";

export const TestCheckApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // GET ALL QuestionTechnology 

    getAllTestCheckWithPagination: builder.query({
      providesTags: ["test-check"],
      query: (body) => {
        return {
          url: "/test-attempt/all-attempted-test",
          method: "POST",
          body
        };
      },
    }),
    // Add
    checkTestAttempt: builder.mutation({
      invalidatesTags: ["test-check"],
      query: (body) => {
        return {
          url: "/test-attempt/update-score",
          method: "PUT",
          body,
        };
      },
    }),

    // GET
    // GET TestQuestion BY ID
    getTestCheckById: builder.query({
      providesTags: ["test-check"],
      query: ({ id }) => {
        return {
          url: `/test-attempt/get-attepted-test/${id}`,
          method: "GET",
        };
      },
    }),


  }),
});

export const {
  useGetAllTestCheckWithPaginationQuery,
  useCheckTestAttemptMutation,
  useGetTestCheckByIdQuery
} = TestCheckApi;
